import type { SpaceEntry } from '../types.js'
import { cloneSpaceEntry, normalizeSpaceEntry } from './spaceCodec.js'

export { cloneBlock } from './spaceCodec.js'

export const EDITOR_BLOCKS_STORE = 'editor_blocks'

export class EditorMemory {
  constructor(private readonly db: IDBDatabase) {}

  async loadEditorBlocks(): Promise<SpaceEntry[]> {
    const blocks = await readAllBlocks(this.db, EDITOR_BLOCKS_STORE)
    return sortBlocks(blocks)
  }

  async replaceEditorBlocks(blocks: SpaceEntry[]): Promise<void> {
    const normalized = blocks.map(cloneSpaceEntry)
    const tx = this.db.transaction([EDITOR_BLOCKS_STORE], 'readwrite')
    const store = tx.objectStore(EDITOR_BLOCKS_STORE)
    store.clear()
    for (const block of normalized) {
      store.put(block, block.ided[0])
    }
    await waitForTransaction(tx)
  }

  async clearEditorBlocks(): Promise<void> {
    const tx = this.db.transaction([EDITOR_BLOCKS_STORE], 'readwrite')
    tx.objectStore(EDITOR_BLOCKS_STORE).clear()
    await waitForTransaction(tx)
  }
}

export function sortBlocks(blocks: SpaceEntry[]): SpaceEntry[] {
  return blocks.slice().sort((a, b) => {
    const aId = a?.ided?.[0] ?? ''
    const bId = b?.ided?.[0] ?? ''
    return aId.localeCompare(bId)
  })
}

export function readAllBlocks(db: IDBDatabase, storeName: string): Promise<SpaceEntry[]> {
  return new Promise((resolve, reject) => {
    const tx = db.transaction([storeName], 'readonly')
    const request = tx.objectStore(storeName).getAll()
    request.onerror = () => reject(request.error)
    request.onsuccess = () => {
      try {
        resolve((request.result ?? []).map(normalizeSpaceEntry))
      } catch (error) {
        reject(error)
      }
    }
  })
}

export function waitForTransaction(tx: IDBTransaction): Promise<void> {
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve()
    tx.onabort = () => reject(tx.error ?? new Error('Transaction aborted'))
    tx.onerror = () => reject(tx.error ?? new Error('Transaction failed'))
  })
}
